/**
 * Nano Banana（gemini-2.5-flash-image）manifest
 * 数据来源：image.json field_map
 * 特点：无清晰度/质量分档；比例不带真实像素；参考图上限 14；支持 @ 参考图
 */
import type { ImageModelConfig } from '../../types';

export const nanoBanana: ImageModelConfig = {
  id: '01K5THTW746GEAV0DMAN8GR9S8',
  isDefault: true,
  displayName: 'Nano Banana',

  defaults: {
    ratio: '9:16', // 接口 select: true 项
  },

  ratioOptions: {
    '*': [
      { label: '1:1', value: '1:1' },
      { label: '2:3', value: '2:3' },
      { label: '3:2', value: '3:2' },
      { label: '3:4', value: '3:4' },
      { label: '4:3', value: '4:3' },
      { label: '9:16', value: '9:16' },
      { label: '16:9', value: '16:9' },
      { label: '21:9', value: '21:9' },
    ],
  },

  resolutionOptions: [],
  qualityOptions: [],

  // 支持 @ 参考图（Banana 系列）
  supportAtMention: true,

  toggles: {},

  limits: {
    maxRefImages: 14, // 接口 field_map.ref_images.max
  },
};
